module.exports = __webpack_public_path__ + "media/winner_double_line_2.8c31ad3a.mp3";